module.exports = __webpack_public_path__ + "img/good5.c532f3ff.png";